<template>
  <div>
    <v-data-table
      hide-default-footer
      class="elevation-1"
      sort-by="creationDate"
      sort-desc
      :headers="headers"
      :items="offers"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :item-class="rowClass"
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-btn tile color="primary" class="link non-text-transformation" @click="createOffer(DEFAULT_ES_MODEL)">
            {{ $t('ADMIN_OFFERS_CREATE_BUTTON') }}
          </v-btn>
          <v-btn tile color="primary" class="link non-text-transformation" style="margin-left: 10px" @click="createOffer(DEFAULT_PT_MODEL)">
            {{ $t('ADMIN_OFFERS_CREATE_BUTTON_PT') }}
          </v-btn>

          <v-spacer class="mx-4" />

          <div class="d-flex align-center text-body-2">
            <div class="mr-2">{{ $t('ADMIN_TABLE_RESULTS_PER_PAGE') }}</div>

            <v-select
              dense
              v-model="itemsPerPage"
              :items="perPageValues"
              class="admin__results-per-page"
            />
          </div>
        </v-toolbar>
      </template>

      <template v-slot:item.creationDate="{ item }">
        <span>{{ formatDate(item.creationDate) }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
      </template>

      <template v-slot:no-data>
        <div class="mt-4 mb-2 text-body-2 admin__no-data">
          {{ $t('ADMIN_TABLE_NO_RESULTS') }}
        </div>

        <v-btn color="primary" class="mb-4" @click="requestOffers">
          {{ $t('ADMIN_UPDATE') }}
        </v-btn>
      </template>

      <template v-slot:footer>
        <v-pagination class="py-4" v-model="page" :length="pageCount" />
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="510">
      <v-card>
        <v-card-title class="text-h3">{{ $t('ADMIN_OFFERS_MODAL_EDIT_TITLE') }}</v-card-title>

        <v-card-actions class="d-flex justify-end pa-4">
          <v-btn tile outlined color="black" class="link non-text-transformation" @click="close">
            {{ $t('ADMIN_CANCEL') }}
          </v-btn>

          <v-btn tile color="primary" class="link non-text-transformation" @click="confirmEdit">
            {{ $t('ADMIN_CONTINUE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { REQUEST_OFFER_LIST, CREATE_OFFER, REQUEST_OFFER_DATA } from '@/store/modules/offer/actions'
import { DEFAULT_RATE_MODEL_ID } from '@/helpers/constants'

export default {
  name: 'Offers',
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      perPageValues: [5, 10, 25, 50, 100],
      DEFAULT_PT_MODEL: process.env.VUE_APP_DEFAULT_PT_MODEL,
      DEFAULT_ES_MODEL: process.env.VUE_APP_DEFAULT_ES_MODEL,
      headers: [
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_ID'),
          value: 'offerId',
          sortable: false,
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_TYPE'),
          value: 'type',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_STATUS'),
          value: 'status',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_VALIDATION_STATUS'),
          value: 'validationStatus',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_COMMERCIAL'),
          value: 'commercial',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_OFFERS_TABLE_HEADER_CREATION_DATE'),
          value: 'creationDate',
          class: 'text-body-2',
        },
        {
          text: this.$t('ADMIN_TABLE_HEADER_ACTIONS'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: 'text-body-2',
        },
      ],
      offers: [],
      editedIndex: -1,
      dialog: false,
    }
  },
  methods: {
    ...mapActions('offer', [REQUEST_OFFER_LIST, CREATE_OFFER, REQUEST_OFFER_DATA]),
    ...mapMutations('process', ['setIsProcessStarted']),
    ...mapActions('alerts', ['createAlert']),
    async setOffer(offerId) {
      const response = await this[REQUEST_OFFER_DATA]({
        offerId,
      })

      if ('error' in response) {
        this.$router.push('/')
      } else {
        this.setIsProcessStarted(true)
        this.$router.push(`/offers/${offerId}?role=comercial`)
      }
    },
    async requestOffers() {
      const response = await this[REQUEST_OFFER_LIST]()

      if ('error' in response) {
        this.createAlert({
          id: 'adminOffers',
          type: 'error',
          contentKey: 'ADMIN_ALERT_TEXT',
          dismissible: false,
          details: response.error,
        })
      } else {
        this.offers = response.data
      }
    },
    editItem(item) {
      this.editedIndex = this.offers.indexOf(item)
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    confirmEdit() {
      this.setOffer(this.offers[this.editedIndex].offerId)
      this.close()
    },
    async createOffer(rateModelId = DEFAULT_RATE_MODEL_ID) {
      const objToSend = {
        offerExternalId: '300000852446261',
        currencyISO: 'EUR',
        potentialShipments: '237',
        comercialAgent: { id: 0, name: 'David Gutierrez' },
        client: {
          id: 1,
          cif: 'G35956408',
          address: 'C. de Calatrava, 27 28005 Madrid',
          city: 'Madrid',
          businessName: 'Test Redradix',
          email: this.$route.query.email || process.env.VUE_APP_SIGNIT_EMAIL,
        },
        bankDetails: {
          accountIBAN: 'ES6930584958791873013472',
        },
        optyServicePoints: [
          {
            servicePointExtId: '3113634',
            isoCountry: '1ES',
            address1: 'calle Alcalá 506',
            address2: 'piso 2º, puerta C',
            postalCode: '28010',
            cityName: 'Madrid',
            provinceName: 'MADRID',
            compromisedShipments: 237,
            isFavorite: false,
          },
        ],
      }
        const payload = {
          objToSend,
          rateModelId,
        }
      const response = await this[CREATE_OFFER](payload)

      if ('error' in response) {
        this.createAlert({
          id: 'adminCreateOffer',
          type: 'error',
          contentKey: 'ADMIN_ALERT_TEXT',
          details: response.error,
        })
      } else {
        const [, offerId] = response.headers.location.match(/.*\/offers\/(.*)/)
        this.setOffer(offerId)
      }
    },
    formatDate(dateString) {
      const dateStringRegex = /([0-9]{4})([0-9]{2})([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})/

      if (dateStringRegex.test(dateString)) {
        const [, year, month, day, hours, minutes, seconds] = dateString.match(dateStringRegex)
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
      }

      return ''
    },
    rowClass() {
      return 'text-body-2'
    },
  },
  created() {
    this.requestOffers()
  },
}
</script>

<style scoped lang="scss">
.admin {
  &__no-data {
    color: #444444;
  }
  &__results-per-page {
    width: rem(60);
  }
}
</style>
